import { render, staticRenderFns } from "./SiloCard.vue?vue&type=template&id=1e321516&scoped=true&"
import script from "./SiloCard.vue?vue&type=script&lang=js&"
export * from "./SiloCard.vue?vue&type=script&lang=js&"
import style0 from "./SiloCard.vue?vue&type=style&index=0&id=1e321516&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e321516",
  null
  
)

export default component.exports